export default __webpack_public_path__ + "static/media/Stalker's Leggings of Arcane Death.3d1067a7.jpg";